<div style="margin-top: 1vh;">
    <span cdkFocusInitial></span>
    <app-board-select-settings
            [widget]="widget"
            [multiChoice]="false"
            [optionDictKey]="'alias'">
    </app-board-select-settings>
</div>
